import styled from 'styled-components'

export const Footer = styled.footer`
  height: 83px;
  background: ${(props) => props.background || '#f7f7f7'};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Logo = styled.img`
  height: 32px;
`

export const Title = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: 500;
  color: #999999;
  margin-right: 10px;
`
